// pages/Oati/OattUploadPage.tsx
import { useApolloClient } from '@apollo/client';
import OattFileUpload from '@components/oatt-upload/OattFileUpload';
import PageLayout from '@components/layout/PageLayout';
import { GET_OATT_FILE_INGESTION_LOGS } from '@graphql/oatt.gql';
import OattIngestionLogsTable from './OattIngestionLogsTable';
import styles from './OattPages.module.css';

const OattUploadPage = () => {
  const client = useApolloClient();

  const handleUploadComplete = () => {
    client.refetchQueries({ include: [GET_OATT_FILE_INGESTION_LOGS] });
  };

  return (
    <PageLayout title="OATT File Upload">
      <div className={styles.content}>
        <OattFileUpload onUploadComplete={handleUploadComplete} />
        <OattIngestionLogsTable />
      </div>
    </PageLayout>
  );
};

export default OattUploadPage;
